module.exports = __webpack_public_path__ + "static/a-xx-118-art-19470ec99628d5f5e9f3ece075c36439.jpg";